import { Chart, ChartOption } from './Chart';
import { Box } from '@mui/material';

type DataPoint = {
  ano: number;
  valor: number;
};

type PropsType = {
  backgroundStyle?: boolean;
  lineColor?: string;
  pointColor?: string;
  title?: string;
  data: DataPoint[];
};

const FrequencyChart: React.FC<PropsType> = ({backgroundStyle = false, lineColor, pointColor, title, data}) => {
  
  const years = data.map(point => point.ano.toString());
  const values = data.map(point => point.valor);

  const option = {
    title: {
      text: title,
      padding: [
        16,
        5,
        5,
        23,
      ],
      textStyle: {
        fontSize: '14px'
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        }
      }
    },
    legend: {
      data: ['Ano x Score geral'],
      right: '0',
      padding: [
        32,
        23,
        5,
        5,
      ],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: years,
    },
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          margin: 30,
        },
      }
    ],
    series: [
      {
        name: 'Ano x Score geral',
        type: 'line',
        smooth: true,
        stack: 'Total',
        label: {
          show: true,
          position: 'bottom',
          color: pointColor
        },
        symbol: '',
        symbolSize: 20,
        areaStyle: {
          color: backgroundStyle ? 'rgba(252, 159, 159, 0.6)' : 'transparent'
        },
        lineStyle: {
          color: lineColor,
          width: 4,
        },
        itemStyle: {
          borderWidth: 1,
          color: pointColor
        },
        emphasis: {
          focus: 'series'
        },
        data: values,
      }
    ]
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default FrequencyChart;
